import { useMemo, useSyncExternalStore } from 'react';
import {
    type BaseFields,
    type BaseFormActions,
    type BaseValidationError,
    type FormDeclaration,
} from '@adv-frontend/form-kit';

export function useFormIsInitialized<
    FormName extends string,
    FormFields extends BaseFields,
    FormValidationError extends BaseValidationError,
    FormContextInput,
    FormContext,
    FormActions extends BaseFormActions,
    FormSubmitArg,
    FormSubmitReturnValue,
>(
    form: FormDeclaration<
        FormName,
        FormFields,
        FormValidationError,
        FormContextInput,
        FormContext,
        FormActions,
        FormSubmitArg,
        FormSubmitReturnValue
    >,
    id: string
) {
    const formInstance = useMemo(() => form.getInstance(id), [form, id]);

    // eslint-disable-next-line react-hooks/immutability -- Автоматический игнор в рамках DIRECT-312943
    const subscriber = useMemo(() => {
        let listener: ((isInitialized: boolean) => void) | undefined;

        const timer = setInterval(tryToSubscribe, 100);

        function tryToSubscribe() {
            if (formInstance.isInitialized()) {
                listener?.(true);
                clearInterval(timer);
            }
        }

        return (cb: (isInitialized: boolean) => void) => {
            // eslint-disable-next-line react-hooks/immutability -- Автоматический игнор в рамках DIRECT-288723
            listener = cb;

            if (formInstance.isInitialized()) {
                cb(true);
            }

            return () => {
                clearInterval(timer);
            };
        };
    }, [formInstance]);

    return useSyncExternalStore<boolean>(
        subscriber,
        () => formInstance.isInitialized(),
        () => false
    );
}
